import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarUndoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.11 11.32C18.29 9.50999 15.54 8.59999 11.71 8.51999V4.78999C11.73 4.28999 11.1 3.97999 10.71 4.28999L1.85001 10.87C1.23001 11.3 1.23001 12.31 1.85001 12.74L10.71 19.31C11.1 19.62 11.72 19.31 11.71 18.81V15.15C15.94 15.15 19.57 15.31 21.45 19.08C21.72 19.67 22.65 19.44 22.63 18.8C22.63 15.46 21.81 13.01 20.11 11.32Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarUndoIcon.displayName = 'ToolbarUndoIcon';
